export const inboundOutboundCSVHeaders = ['Source Category', 'Applied', 'Screening', 'Assessment', 'Offer', 'Hired'];
